import YouTubePlayer from 'youtube-player';

class Video {
    constructor(el) {
        if (!el) return;
        this.root = el;

        this.init();
    }

    init() {
        this.type = this.root.getAttribute('data-type') || 'file';
        this.thumbnail = this.root.querySelector('[js-thumbnail]');
        this.video = this.root.querySelector('video');
        this.iframe = this.root.querySelector('iframe');
        this.player = this.iframe ? YouTubePlayer(this.iframe) : null;

        this.events();
    }

    events() {
        if (this.thumbnail) {
            this.thumbnail.addEventListener(
                'click',
                this.onThumbnailClick.bind(this)
            );
        }

        if (this.video) {
            this.video.addEventListener('click', this.onVideoClick.bind(this));
        }
    }

    onThumbnailClick() {
        if (this.thumbnail.classList.contains('-hidden')) {
            this.pause();
            return;
        }

        this.play();
    }

    onVideoClick() {
        if (!this.thumbnail?.classList.contains('-hidden')) {
            return;
        }

        this.pause();
    }

    play() {
        this.thumbnail.classList.add('-hidden');

        if (this.type === 'file') {
            this.video.play();
        } else {
            this.player.playVideo();
        }
    }

    pause() {
        this.thumbnail.classList.remove('-hidden');

        if (this.type === 'file') {
            this.video.pause();
        } else {
            this.player.pauseVideo();
        }
    }
}

const videos = document.querySelectorAll('[js-video]');
if (videos.length) {
    videos.forEach(element => {
        new Video(element);
    });
}
